// Gender on a league registration.
//
// Asked at sign-up rather than read from an account, for two reasons. Users
// carry no gender at all, and only about two thirds of adult athlete records
// have one — so anything derived would be guessing for a third of a league.
// And a registration is the thing a roster rule is checked against, so the
// answer belongs on the row being counted.
//
// The values match what athlete records already use, so the two never have to
// be reconciled. "Prefer not to say" is kept deliberately: dropping it would
// not stop people declining, it would just make them pick something untrue.

export const GENDERS = ['Female', 'Male', 'Non-binary', 'Prefer not to say'];

export const isValidGender = (v) => GENDERS.includes(String(v || '').trim());

/**
 * Whether this league's type means the answer is already known.
 *
 * A women's league is women; asking each registrant to confirm it is a field
 * that can only be answered one way. Coed leagues are the ones that need it,
 * and are also the ones with a roster rule that depends on it.
 */
export const impliedGender = (leagueType) => {
  if (leagueType === 'womens' || leagueType === 'junior_girls') return 'Female';
  if (leagueType === 'mens' || leagueType === 'junior_boys') return 'Male';
  return '';
};

/** The label to ask under, which differs when a parent is answering. */
export const genderLabel = (juniors) => (juniors ? "Player's gender" : 'Gender');
